import type { VariantInfo, Campaign, ICampaignVariantVersion } from '~/modules/campaign/types';
import type { ICGTemplateVariantProperty } from '../types';

import { CGTemplatePairProperty } from './CGTemplatePairProperty';
import { GTable } from '~/presentation/ui';

interface CGTemplatePairVariantCellProps {
  variant: VariantInfo;
  property: ICGTemplateVariantProperty;
  campaign: Campaign;
  variantIndex: number;
  columnIndex: number;
  isPropertyIgnored: boolean;
  parsePaddingRow: (index: number) => any;
  campaignVariants?: Record<string, ICampaignVariantVersion>;
}

const shouldSkipRender = (isPropertyIgnored: boolean, variantIndex: number) => {
  return isPropertyIgnored && variantIndex !== 0;
};

export const CGTemplatePairVariantCell: React.FC<CGTemplatePairVariantCellProps> = ({
  variant,
  property,
  campaign,
  variantIndex,
  columnIndex,
  isPropertyIgnored,
  parsePaddingRow,
  campaignVariants,
}) => {
  if (shouldSkipRender(isPropertyIgnored, variantIndex)) return null;

  return (
    <div key={`variant-${variant.id}`} className="Polaris-GTable-Cell">
      <GTable.Cell key={variant.id} index={columnIndex} padding={parsePaddingRow(columnIndex)}>
        <CGTemplatePairProperty
          campaign={campaign}
          variant={variant}
          property={property}
          campaignVariants={campaignVariants}
        />
      </GTable.Cell>
    </div>
  );
};
